const MapSidebar = ({ shippers }: { shippers: any[] }) => {
  return (
    <div
      className=" overflow-y-auto bg-white shadow-md"
      style={{
        height: "calc(100vh - 80px)",
      }}
    >
      <h2 className="text-xl font-bold mb-4 p-3">Dropped Trailers</h2>
      <ul className="space-y-3">
        {shippers.map((shipper) => (
          <li key={shipper.id} className="p-3  border-b hover:bg-gray-100">
            <div className="font-semibold text-gray-800">{shipper.name}</div>
            <div className="text-sm text-gray-500">{shipper.address}</div>
            <div className="text-sm text-blue-600 mt-1">
              Trailer: {shipper.count}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MapSidebar;
